import {
  DropdownIndicator,
  formatGroupLabel,
  getTranslatedText,
  IndicatorSeparator
} from '@nile/components';
import { Dropdown, TextField } from '@superops/ui-design-system';
import React from 'react';
import styled from 'styled-components';

const maxRepeatInterval = {
  DAY: 31,
  WEEK: 4,
  MONTH: 12
  // YEAR: 10
};

const FrequencyInputField = styled.div`
  margin-top: 24px;
  width: 200px;
  min-width: 200px;
  .item-quantity {
    padding-left: 0 !important;
  }
  .react-datepicker__input-container > input {
    height: 38px;
    width: 200px;
  }

  .Superops-TextField {
    align-items: initial;
  }
  .Superops-TextField__Input:focus,
  .Superops-TextField__Input:focus:hover {
    border-bottom: 0.1rem solid var(--sops-border-normal) !important;
    & + .Superops-TextField__ActionableSuffix {
      border-bottom: 0.1rem solid var(--sops-border-normal) !important;
    }
  }

  .value_selector__control {
    width: 100px !important;
    border: none !important;
  }
`;

const FrequencySelectField = (props) => {
  const {
    intl,
    frequency,
    onChange,
    customSubscriptionTypes,
    isDisabled
  } = props;

  const unit = frequency?.unit;

  let subscriptionType = customSubscriptionTypes.find((el) => {
    return el.value === unit;
  });

  if (!subscriptionType) {
    subscriptionType = customSubscriptionTypes.find((el) => {
      return el.value === 'MONTH';
    });
  }

  return (
    <FrequencyInputField className="pt10">
      <TextField
        value={frequency?.quantity?.toString()}
        onChange={(val) => {
          onChange({
            unit: frequency?.unit || 'MONTH',
            quantity: val,
            recurringBefore: frequency?.recurringMode === 'ADVANCE' ? '0' : null
          });
        }}
        onBlur={() => {
          if (frequency?.quantity < 1) {
            onChange({
              unit: frequency?.unit || 'MONTH',
              quantity: '1'
            });
          }
        }}
        customClassName="w50 text-input"
        type="number"
        min={1}
        placeholder="1"
        max={maxRepeatInterval[unit]}
        disabled={isDisabled}
        suffix={
          <Dropdown
            name="subscriptionTypes"
            value={subscriptionType}
            onChange={(val) => {
              onChange({
                quantity:
                  frequency?.quantity < maxRepeatInterval[unit]
                    ? frequency?.quantity
                    : '1',
                unit: val?.value || 'MONTH',
                recurringBefore:
                  frequency?.recurringMode === 'ADVANCE' ? '0' : null
              });
            }}
            options={customSubscriptionTypes}
            components={{
              IndicatorSeparator,
              DropdownIndicator
            }}
            classNamePrefix="value_selector"
            formatGroupLabel={formatGroupLabel}
            menuPlacement="auto"
            placeholder={getTranslatedText(
              intl,
              'admin.serviceCatalog.subscriptionType.custom.type.placeholder'
            )}
            closeMenuOnScroll={(e) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, zIndex: 9999 })
            }}
            isDisabled={isDisabled}
          />
        }
      />
    </FrequencyInputField>
  );
};

export default FrequencySelectField;
